/**
 * @file SubMenu.js.
 * @author Sérgio Ferraz Souza <todentro@gmail.com>
 * @copyright Cognatis GeoAnalytics & Big Data Ltda :: 2026
 */

import Request from '../components/http/request'
import Service from './Service'

const defaultJsonHeaders = {
  headers: {
    'Content-Type': 'application/json'
  }
}

/**
 * SubMenu Management Service
 * @class
 */
class SubMenu extends Service {
  constructor(options, resource) {
    super(options)
    this.resource = resource
    this.request = new Request({tag: 'das'})
  }

  async create (payload) {
    return new Promise((resolve, reject) => {
      if (typeof payload === 'undefined') reject(new Error('Esperado o payload'))
      let endPoint = `/api/0.1-a/submenu/`
      this.request.post(endPoint, payload, defaultJsonHeaders)
        .then(res => resolve(res))
        .catch(() => reject())
    })
  }

  async deleteByLayer(menuId, layerId) {
    return new Promise((resolve, reject) => {
      if (typeof menuId === 'undefined') reject(new Error('Esperado o identificador do Menu'))
      if (typeof layerId === 'undefined') reject(new Error('Esperado o identificador do Layer'))
      let endPoint = `/api/0.1-a/submenu/layer/${menuId}/${layerId}`
      this.request.delete(endPoint, defaultJsonHeaders)
        .then(res => resolve(res))
        .catch(() => reject)
    })
  }

  async getParentId (layerId) {
    return new Promise((resolve, reject) => {
      if (typeof layerId === 'undefined') reject(new Error('Esperado o identificador do layerid'))
      let endPoint = `/api/0.1-a/submenu/layer/${layerId}`
      this.request.get(endPoint, defaultJsonHeaders)
        .then(res => resolve(res))
        .catch(() => reject())
    })
  }

  async getMenu (environmentId) {
    return new Promise((resolve, reject) => {
      if (typeof environmentId === 'undefined') reject(new Error('Esperado o identificador do ambiente'))
      let endPoint = `/api/0.1-a/menu/default/${environmentId}`
      this.request.get(endPoint, defaultJsonHeaders)
        .then(res => resolve(res))
        .catch(() => reject())
    })
  }

  async getSubMenu (subMenuId) {
    return new Promise((resolve, reject) => {
      if (typeof subMenuId === 'undefined') reject(new Error('Esperado o identificador do SubMenu'))
      let endPoint = `/api/0.1-a/submenu/${subMenuId}`
      this.request.get(endPoint, defaultJsonHeaders)
        .then(res => resolve(res))
        .catch(() => reject())
    })
  }

  async getSubMenu2 (menuId, layerId) {
    return new Promise((resolve, reject) => {
      if (typeof menuId === 'undefined') reject(new Error('Esperado o identificador do Menu'))
      if (typeof layerId === 'undefined') reject(new Error('Esperado o identificador do Layer'))
      let endPoint = `/api/0.1-a/submenu/layer/${menuId}/${layerId}`
      this.request.get(endPoint, defaultJsonHeaders)
        .then(res => resolve(res))
        .catch(() => reject())
    })
  }

}

export { SubMenu }
